import React, { useState, useEffect } from "react";
import CollectionForm from "./components/CollectionForm";
import { HeaderSection } from "@/components/shared/header-section";
import { useLazyQuery, useMutation } from "@apollo/client";
import { DataTableManual } from "@/components/shared/data-table-manual/data-table-manual";
import { DataTableToolbar } from "@/components/shared/data-table-manual/data-table-toolbar-manual";
import { getColumns } from "./components/columns";
import { GET_COLLECTIONS, DELETE_MANY_COLLECTIONS } from "./collectionsQueries";
import { Button } from "@/components/ui/button";
import useOpenDrawer from "@/hooks/useOpenDrawer";
import { useDeleteConfirmation } from "@/hooks/useDeleteConfirmation";
import { PageContent } from "@/components/shared/page-content";
import { getOrderSortParams } from "@/utils/orderUtils";
import { useLanguage } from "@/context/LanguageContext";

export default function Collections() {
  const { language } = useLanguage();
  const [searchTerm, setSearchTerm] = useState("");
  const [tableData, setTableData] = useState([]);
  const [tableDataCount, setTableDataCount] = useState(0);
  const [order, setOrder] = useState([]);
  const [filters, setFilters] = React.useState<Map<string, Set<string>>>(
    new Map()
  );

  const [pagination, setPagination] = React.useState({
    pageIndex: 0,
    pageSize: 20,
  });

  const [loadCollections, { data, error, loading }] = useLazyQuery(
    GET_COLLECTIONS,
    {
      variables: {},
      fetchPolicy: "cache-and-network",
    }
  );

  const { onDelete } = useDeleteConfirmation({
    mutation: DELETE_MANY_COLLECTIONS,
    refetchQueries: ["GET_COLLECTIONS"],
    messages: {
      success: "Collection deleted successfully",
      error: "Failed to delete collection",
    },
    itemName: "collection",
  });

  // Load collections data
  useEffect(() => {
    loadCollections({
      variables: {
        searchTerm,
        language,
        take: pagination.pageSize,
        skip: pagination.pageIndex * pagination.pageSize,
        orderBy: getOrderSortParams(order),
      },
    });
  }, [searchTerm, pagination, order, language]);

  // Reset pagination when search or page size changes
  useEffect(() => {
    setPagination({ ...pagination, pageIndex: 0 });
  }, [searchTerm, pagination.pageSize, order]);

  // Update table data when query results change
  useEffect(() => {
    if (data) {
      setTableData(data.findManyCollection);
      setTableDataCount(data.findManyCollectionCount);
    }
  }, [data]);

  const openCollectionForm = useOpenDrawer(CollectionForm);
  const columns = getColumns(openCollectionForm);

  return (
    <PageContent>
      <div className="flex justify-between items-center">
        <HeaderSection
          title="Collections"
          subtitle="Manage your product collections here"
        />
        <Button onClick={openCollectionForm}>Create New +</Button>
      </div>
      <DataTableManual
        data={tableData}
        columns={columns}
        rowCount={tableDataCount}
        pageIndex={pagination.pageIndex}
        pageSize={pagination.pageSize}
        onPaginationChange={setPagination}
        onSortingChange={setOrder}
        onColumnFiltersChange={setFilters}
        onRowClick={openCollectionForm}
        isLoading={loading}
        toolbar={(table: any) => (
          <DataTableToolbar
            table={table}
            config={{
              onDelete: onDelete,
              search: {
                placeholder: "Filter collections...",
                accessor: "name",
                onSearch: setSearchTerm,
                onFilter: setFilters,
              },
              columns: [
                // {
                //   title: "Language",
                //   accessor: "collection_profiles.language",
                //   options: [
                //     { label: "English", value: "EN" },
                //     { label: "Lithuanian", value: "LT" },
                //   ],
                // },
              ],
            }}
          />
        )}
      />
    </PageContent>
  );
}
